/**
 * Redirections des quatre anciennes pages de statistiques (LOT-H12-ANALYTICS).
 *
 * `/dashboard-analytics` et `/metrics` ont fusionné en `/analytics` ;
 * `/monitoring` et `/admin/realtime-stats` en `/supervision` (recette DA §5),
 * elle-même devenue `/accueil` (L-NAV-8).
 * Les anciens chemins vivent dans des signets, des liens partagés et
 * l'historique des navigateurs : ils REDIRIGENT, ils ne cassent pas.
 *
 * Les gardes de rôle ne sont pas dupliquées ici : `/accueil` porte déjà
 * `ProtectedRoute requiredRole="ADMIN"` — un agent qui suit un vieux signet
 * `/monitoring` aboutit exactement où il aboutissait avant : sur le refus
 * d'accès.
 *
 * `replace` : la redirection ne laisse pas d'entrée d'historique, sinon le
 * bouton « précédent » boucle (même décision que `publicOnlyRedirects`).
 *
 * Le helper est exporté — et non écrit en clair dans `App.tsx` — pour que
 * `legacyStatsRedirects.spec.tsx` monte les VRAIES routes de production.
 */
import { Navigate, Route } from 'react-router-dom'

/** Ancien chemin → nouvelle destination. */
export const LEGACY_STATS_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/dashboard-analytics', to: '/analytics' },
  { from: '/metrics', to: '/analytics' },
  // L-NAV-8 : `/supervision` est devenue `/accueil` — ses deux ancêtres y vont
  // directement (pas de double saut par `/supervision`).
  { from: '/monitoring', to: '/accueil' },
  { from: '/admin/realtime-stats', to: '/accueil' },
]

/** Routes à insérer dans l'arbre AUTHENTIFIÉ, avant le `*` de la 404. */
export function legacyStatsRedirects() {
  return LEGACY_STATS_REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<Navigate to={to} replace />} />
  ))
}
